export default () => ({
    formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        message: ''
    },
    init() {

    }
})
